import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {FormGroupComponent} from '../../components/form-group/form-group.component';
import {UserSessionService} from '../../services/user-session-service/user-session.service';
import {FormErrorService} from '../../services/form-error-service/form-error.service';
import {RedirectUrlService} from '../../services/redirect-url-service/redirect-url.service';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    FormGroupComponent,
    RouterLink
  ],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  private userSessionService = inject(UserSessionService);
  private formErrorService = inject(FormErrorService);
  private redirectUrlService = inject(RedirectUrlService);
  private router = inject(Router);

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', Validators.required),
  });

  onSubmit() {
    this.userSessionService.login(this.form.value.email ?? '', this.form.value.password ?? '')
      .subscribe({
        next: () => {
          const validRedirectUrl = this.redirectUrlService.getValidRedirectUrl();

          if (validRedirectUrl) {
            this.redirectUrlService.clearRedirectUrl();
            this.router.navigateByUrl(validRedirectUrl);
          } else {
            this.router.navigate(['/']);
          }
        },
        error: response => this.formErrorService.mapErrorToForm(this.form, response),
      });
  }
}
